import { useState } from "react";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";

import { ROUTE } from "@/route/app_routes.js";

const CHECKLIST_KEYS = ["certificate", "portfolioWork", "shareableCredential"];
const CHECKLIST_DEFAULTS = [
  "A verifiable certificate for every course you finish",
  "Real, project-based work you can put straight into a portfolio",
  "A shareable credential link, ready for LinkedIn or a resume",
];

const OutcomesBand = () => {
  const { t } = useTranslation("home");
  const router = useRouter();
  const [number, setNumber] = useState("");
  const [error, setError] = useState("");

  const checklist = CHECKLIST_KEYS.map((key, i) => t(`outcomes.checklist.${key}`, CHECKLIST_DEFAULTS[i]));

  const handleVerify = (e) => {
    e.preventDefault();
    const trimmed = number.trim();
    if (!trimmed) {
      setError(t("outcomes.verifyError", "Enter a certificate number to verify."));
      return;
    }
    setError("");
    router.push(`${ROUTE.certificateVerify}${encodeURIComponent(trimmed)}`);
  };

  return (
    <div className="rbt-outcomes">
      <div className="container">
        <div className="rbt-outcomes__grid">
          <div>
            <span className="rbt-outcomes__eyebrow">{t("outcomes.eyebrow", "What you walk away with")}</span>
            <h2 className="rbt-outcomes__title">
              {t("outcomes.title", "A portfolio and a certificate — not just a login you forget about")}
            </h2>
            <p className="rbt-outcomes__desc">
              {t(
                "outcomes.desc",
                "Finishing a course here means you built something real. It also means a certificate that anyone — a recruiter, a client, you in six months — can verify in seconds."
              )}
            </p>

            <ul className="rbt-outcomes__checklist">
              {checklist.map((item) => (
                <li key={item}>
                  <span className="rbt-outcomes__check">
                    <i className="feather-check"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <form className="rbt-outcomes__verify" onSubmit={handleVerify}>
              <input
                type="text"
                placeholder={t("outcomes.verifyPlaceholder", "Enter a certificate number to verify")}
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                aria-label={t("outcomes.verifyAriaLabel", "Certificate number")}
              />
              <button type="submit">{t("outcomes.verifyButton", "Verify")}</button>
            </form>
            {error && <p className="rbt-outcomes__hint rbt-outcomes__hint--error">{error}</p>}
            {!error && (
              <p className="rbt-outcomes__hint">
                {t("outcomes.verifyHint", "Every certificate we issue carries a unique, checkable number.")}
              </p>
            )}
          </div>

          <div className="rbt-cert" aria-hidden="true">
            <span className="rbt-cert__mark">
              <i className="feather-award"></i>
            </span>
            <span className="rbt-cert__label">{t("outcomes.certLabel", "Certificate of Completion")}</span>
            <h3 className="rbt-cert__name">Jordan Ade</h3>
            <p className="rbt-cert__course">{t("outcomes.certCourseName", "Full-Stack Web Development")}</p>
            <div className="rbt-cert__foot">
              <span className="rbt-cert__seal">
                <i className="feather-check"></i>
              </span>
              <span className="rbt-cert__id">STA-29X7K4</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OutcomesBand;
